import { EventEmitter, Component, ChangeDetectionStrategy, ElementRef, ChangeDetectorRef, Input, Output, NgModule } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { breakpointBelow, _log, ResponsiveService } from 'b2c-ui/core';
import { tap } from 'rxjs/operators';
import { I18nTransKey, I18nModule } from 'b2c-ui/i18n';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CommonModule } from '@angular/common';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzTypographyModule } from 'ng-zorro-antd';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { AddToWatchlistIcon, AlertIcon, AlertaddedIcon, B2cUiIconModule, B2CUiIconService } from 'b2c-ui-icon';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-product-bar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'ng-zorro-antd/grid';
import * as ɵngcc4 from 'ng-zorro-antd/avatar';
import * as ɵngcc5 from 'ng-zorro-antd';
import * as ɵngcc6 from 'ng-zorro-antd/divider';
import * as ɵngcc7 from 'ng-zorro-antd/button';
import * as ɵngcc8 from 'ng-zorro-antd/tooltip';
import * as ɵngcc9 from 'b2c-ui-icon';
import * as ɵngcc10 from 'b2c-ui/i18n';

function B2CProductBarComponent_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "span", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.productName);
} }
const _c0 = function (a0) { return { "bg-transparent": a0 }; };
function B2CProductBarComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelement(3, "nz-avatar", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, B2CProductBarComponent_div_2_div_4_Template, 3, 1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("nzSrc", ctx_r0.logo ? ctx_r0.logo : null)("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c0, !ctx_r0.logo));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isMobile);
} }
function B2CProductBarComponent_div_5_nz_divider_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "nz-divider", 21);
} }
function B2CProductBarComponent_div_5_span_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "number");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate3("", ctx_r7.secondValuePrefix, " ", ɵngcc0.ɵɵpipeBind1(2, 3, ctx_r7.secondValue), " ", ctx_r7.secondValueSuffix, "");
} }
function B2CProductBarComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "span", 17);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 16);
    ɵngcc0.ɵɵelementStart(5, "span", 18);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 16);
    ɵngcc0.ɵɵtemplate(9, B2CProductBarComponent_div_5_nz_divider_9_Template, 1, 0, "nz-divider", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 16);
    ɵngcc0.ɵɵelementStart(11, "span", 17);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 16);
    ɵngcc0.ɵɵtemplate(14, B2CProductBarComponent_div_5_span_14_Template, 3, 5, "span", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.firstInfoTitle);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate3("", ctx_r1.firstValuePrefix, " ", ɵngcc0.ɵɵpipeBind1(7, 7, ctx_r1.firstValue), " ", ctx_r1.firstValueSuffix, "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.secondValue);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.secondInfoTitle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.type !== "stock" && ctx_r1.type !== "etf");
} }
function B2CProductBarComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 22);
    ɵngcc0.ɵɵelementStart(2, "span", 23);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 24);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.firstInfoTitle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate3("", ctx_r2.firstValuePrefix, " ", ɵngcc0.ɵɵpipeBind1(6, 4, ctx_r2.firstValue), " ", ctx_r2.firstValueSuffix, "");
} }
function B2CProductBarComponent_ng_container_8_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 29);
    ɵngcc0.ɵɵlistener("click", function B2CProductBarComponent_ng_container_8_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.addToWatchlist(ctx_r10.isWatchList); });
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 30);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("nzTooltipTitle", "Add to watchlist");
} }
function B2CProductBarComponent_ng_container_8_button_6_b2c_ui_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "b2c-ui-icon", 34);
} }
function B2CProductBarComponent_ng_container_8_button_6_b2c_ui_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "b2c-ui-icon", 35);
} }
function B2CProductBarComponent_ng_container_8_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 31);
    ɵngcc0.ɵɵlistener("click", function B2CProductBarComponent_ng_container_8_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.addToAlert(ctx_r14.isAlertAdded); });
    ɵngcc0.ɵɵtemplate(1, B2CProductBarComponent_ng_container_8_button_6_b2c_ui_icon_1_Template, 1, 0, "b2c-ui-icon", 32);
    ɵngcc0.ɵɵtemplate(2, B2CProductBarComponent_ng_container_8_button_6_b2c_ui_icon_2_Template, 1, 0, "b2c-ui-icon", 33);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("nzTooltipTitle", ctx_r9.isAlertAdded ? "Remove alert" : "Add alert")("ngClass", ctx_r9.isAlertAdded ? "added" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.isAlertAdded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r9.isAlertAdded);
} }
function B2CProductBarComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 25);
    ɵngcc0.ɵɵelementStart(2, "button", 26);
    ɵngcc0.ɵɵlistener("click", function B2CProductBarComponent_ng_container_8_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.onTrade(ctx_r16.productName); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, B2CProductBarComponent_ng_container_8_button_5_Template, 2, 1, "button", 27);
    ɵngcc0.ɵɵtemplate(6, B2CProductBarComponent_ng_container_8_button_6_Template, 3, 4, "button", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 3, ctx_r3.I18nTransKey == null ? null : ctx_r3.I18nTransKey.TRANSACT));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.isMobile);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.isMobile && ctx_r3.alert);
} }
function B2CProductBarComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 36);
    ɵngcc0.ɵɵelementStart(2, "button", 37);
    ɵngcc0.ɵɵlistener("click", function B2CProductBarComponent_ng_container_9_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onTrade(ctx_r18.productName); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 1, ctx_r4.I18nTransKey == null ? null : ctx_r4.I18nTransKey.TRANSACT));
} }
const _c1 = function (a0) { return { "rounded": a0 }; };
const _c2 = function (a0) { return { "isMobile": a0 }; };
const _c3 = function (a0, a1) { return { "text-left": a0, "text-center": a1 }; };
function B2CProductBarFilterComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵlistener("click", function B2CProductBarFilterComponent_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onCancel(ctx_r2.selectedFilter); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.I18nTransKey == null ? null : ctx_r0.I18nTransKey.CANCEL));
} }
const _c4 = function (a0) { return { "my-2": a0 }; };
function B2CProductBarFilterComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function B2CProductBarFilterComponent_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onClear(ctx_r4.selectedFilter); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c4, ctx_r1.isMobile));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r1.I18nTransKey == null ? null : ctx_r1.I18nTransKey.CLEAR_SELECTED_FILTER));
} }
const _c5 = function (a0, a1) { return { "w-100": a0, "isMobile": a1 }; };
function FundInfosInterface() { }
if (false) {
    /** @type {?} */
    FundInfosInterface.prototype.id;
    /** @type {?} */
    FundInfosInterface.prototype.fundName;
    /** @type {?} */
    FundInfosInterface.prototype.logo;
    /** @type {?} */
    FundInfosInterface.prototype.minimuminitialinvest;
    /** @type {?} */
    FundInfosInterface.prototype.minRspNum;
    /** @type {?} */
    FundInfosInterface.prototype.recommendedFund;
    /** @type {?} */
    FundInfosInterface.prototype.volume;
    /** @type {?} */
    FundInfosInterface.prototype.watchList;
}
/**
 * ##### Import this component individually to your module
 * `import { B2CProductBarModule } from 'b2c-ui/product-bar';`
 */
class B2CProductBarComponent {
    /**
     * @ignore
     * @param {?} elementRef
     * @param {?} cdRef
     * @param {?} responsiveService
     */
    constructor(elementRef, cdRef, responsiveService) {
        this.elementRef = elementRef;
        this.cdRef = cdRef;
        this.responsiveService = responsiveService;
        this._showInfo = true;
        /**
         * @ignore
         */
        this.I18nTransKey = I18nTransKey;
        /**
         * set product bar type
         */
        this.type = 'fund';
        /**
         * Transact button change
         */
        this.transact = new EventEmitter();
        /**
         * Watchlist change
         */
        this.watchlistChange = new EventEmitter();
        this.alertChange = new EventEmitter();
        this.responsiveService
            .observeBoolean(breakpointBelow.sm)
            .pipe(tap((/**
         * @param {?} matched
         * @return {?}
         */
        (matched) => {
            this.isMobile = matched;
            this.cdRef.markForCheck();
        })))
            .subscribe();
    }
    /**
     * Set Mobile View
     * @param {?} value
     * @return {?}
     */
    set isMobile(value) {
        this._isMobile = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get isMobile() {
        return this._isMobile;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set alert(value) {
        this._alert = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get alert() {
        return this._alert;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set isAlertAdded(value) {
        this._isAlertAdded = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get isAlertAdded() {
        return this._isAlertAdded;
    }
    /**
     * Set showInfo
     * @param {?} value
     * @return {?}
     */
    set showInfo(value) {
        this._showInfo = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get showInfo() {
        return this._showInfo;
    }
    /**
     * Set product added Watchlist
     * @param {?} value
     * @return {?}
     */
    set isWatchList(value) {
        this._isWatchList = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get isWatchList() {
        return this._isWatchList;
    }
    /**
     * @ignore
     * @param {?} value
     * @return {?}
     */
    onTrade(value) {
        this.transact.emit(value);
        _log('Buy' + value);
    }
    /**
     * @ignore
     * @param {?} value
     * @return {?}
     */
    addToWatchlist(value) {
        this._isWatchList = !value;
        this.watchlistChange.emit(this.isWatchList);
        _log(this.isWatchList);
        _log(this.isWatchList ? 'Add to watchlist' : 'Remove from watchlist');
    }
    /**
     * @ignore
     * @param {?} value
     * @return {?}
     */
    addToAlert(value) {
        this._isAlertAdded = !value;
        this.alertChange.emit(this.isAlertAdded);
        _log(this.isAlertAdded);
        _log(this.isAlertAdded ? 'Add to alert' : 'Remove from alert');
    }
}
B2CProductBarComponent.ɵfac = function B2CProductBarComponent_Factory(t) { return new (t || B2CProductBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService)); };
B2CProductBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CProductBarComponent, selectors: [["b2c-product-bar"]], inputs: { type: "type", isMobile: "isMobile", alert: "alert", isAlertAdded: "isAlertAdded", showInfo: "showInfo", isWatchList: "isWatchList", logo: "logo", productName: "productName", firstInfoTitle: "firstInfoTitle", secondInfoTitle: "secondInfoTitle", firstValue: "firstValue", secondValue: "secondValue", firstValuePrefix: "firstValuePrefix", secondValuePrefix: "secondValuePrefix", firstValueSuffix: "firstValueSuffix", secondValueSuffix: "secondValueSuffix" }, outputs: { transact: "transact", watchlistChange: "watchlistChange", alertChange: "alertChange" }, decls: 10, vars: 16, consts: [[1, "b2c-product-bar", "bg-white", "shadow", "mb-2", 3, "ngClass"], ["nz-row", "", "nzType", "flex", "nzAlign", "middle", 1, "b2c-product-bar-content", 3, "ngClass"], ["nz-col", "", "nzSpan", "7", 4, "ngIf"], ["nz-col", "", "nzSpan", "12"], [1, "b2c-product-bar-investment-info", 3, "ngClass"], ["class", "row", 4, "ngIf"], [4, "ngIf"], ["nz-col", "", 3, "nzSpan"], ["nz-col", "", "nzSpan", "7"], [1, "d-flex", "flex-row"], [1, "mr-1", "align-self-center"], [1, "b2c-product-bar-logo", "img-fluid", "bg-transparent", 3, "nzSrc", "ngClass"], ["class", "b2c-product-title align-self-center", 4, "ngIf"], [1, "b2c-product-title", "align-self-center"], ["nz-text", ""], [1, "row"], [1, "col"], ["nz-text", "", 1, "label"], ["nz-text", "", 1, "value"], ["class", "b2c-product-bar-divider", "nzType", "vertical", 4, "ngIf"], ["nz-text", "", "class", "value", 4, "ngIf"], ["nzType", "vertical", 1, "b2c-product-bar-divider"], [1, "b2c-product-bar-mobile-investment-info"], ["nz-text", "", 1, "mobile-title", "d-flex"], ["nz-text", "", 1, "mobile-value", "d-flex", "font-weight-bold"], ["nz-col", "", 1, "b2c-product-bar-button-container", "text-right"], ["nz-button", "", "nzType", "primary", 1, "b2c-product-bar-btn-transact", "font-weight-bold", 3, "click"], ["nz-button", "", "nz-tooltip", "", "nzType", "default", "class", "btn-outline-icon align-top", 3, "nzTooltipTitle", "click", 4, "ngIf"], ["nz-button", "", "nz-tooltip", "", "nzType", "default", "class", "btn-outline-icon align-top", 3, "nzTooltipTitle", "ngClass", "click", 4, "ngIf"], ["nz-button", "", "nz-tooltip", "", "nzType", "default", 1, "btn-outline-icon", "align-top", 3, "nzTooltipTitle", "click"], ["name", "addToWatchlistIcon"], ["nz-button", "", "nz-tooltip", "", "nzType", "default", 1, "btn-outline-icon", "align-top", 3, "nzTooltipTitle", "ngClass", "click"], ["class", "alert-added", "name", "alertaddedIcon", 4, "ngIf"], ["name", "alertIcon", 4, "ngIf"], ["name", "alertaddedIcon", 1, "alert-added"], ["name", "alertIcon"], [1, "b2c-product-bar-button-container", "text-right"], ["nz-button", "", "nzType", "primary", "nzBlock", "", 1, "b2c-product-bar-btn-transact", 3, "click"]], template: function B2CProductBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, B2CProductBarComponent_div_2_Template, 5, 5, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, B2CProductBarComponent_div_5_Template, 15, 9, "div", 5);
        ɵngcc0.ɵɵtemplate(6, B2CProductBarComponent_ng_container_6_Template, 7, 6, "ng-container", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵtemplate(8, B2CProductBarComponent_ng_container_8_Template, 7, 5, "ng-container", 6);
        ɵngcc0.ɵɵtemplate(9, B2CProductBarComponent_ng_container_9_Template, 5, 3, "ng-container", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c1, ctx.isMobile));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c2, ctx.isMobile));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isMobile);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(13, _c3, ctx.isMobile, !ctx.isMobile));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isMobile && ctx.showInfo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMobile && ctx.showInfo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("nzSpan", ctx.isMobile ? 12 : 5);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showInfo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showInfo);
    } }, directives: [ɵngcc2.NgClass, ɵngcc3.NzRowDirective, ɵngcc2.NgIf, ɵngcc3.NzColDirective, ɵngcc4.NzAvatarComponent, ɵngcc5.NzTypographyComponent, ɵngcc6.NzDividerComponent, ɵngcc7.NzButtonComponent, ɵngcc8.NzTooltipDirective, ɵngcc9.B2CUiIconComponent], pipes: [ɵngcc2.DecimalPipe, ɵngcc10.B2CI18nPipe], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CProductBarComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef },
    { type: ResponsiveService }
];
B2CProductBarComponent.propDecorators = {
    isMobile: [{ type: Input }],
    alert: [{ type: Input }],
    isAlertAdded: [{ type: Input }],
    showInfo: [{ type: Input }],
    isWatchList: [{ type: Input }],
    type: [{ type: Input }],
    logo: [{ type: Input }],
    productName: [{ type: Input }],
    firstInfoTitle: [{ type: Input }],
    secondInfoTitle: [{ type: Input }],
    firstValue: [{ type: Input }],
    secondValue: [{ type: Input }],
    firstValuePrefix: [{ type: Input }],
    secondValuePrefix: [{ type: Input }],
    firstValueSuffix: [{ type: Input }],
    secondValueSuffix: [{ type: Input }],
    transact: [{ type: Output }],
    watchlistChange: [{ type: Output }],
    alertChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CProductBarComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-product-bar',
                template: "<div class=\"b2c-product-bar bg-white shadow mb-2\" [ngClass]=\"{'rounded':isMobile}\">\r\n  <div class=\"b2c-product-bar-content\" nz-row nzType=\"flex\" nzAlign=\"middle\" [ngClass]=\"{'isMobile':isMobile}\">\r\n    <div nz-col nzSpan=\"7\" *ngIf=\"!isMobile\">\r\n        <div class=\"d-flex flex-row\">\r\n          <div class=\"mr-1 align-self-center\">\r\n            <nz-avatar class=\"b2c-product-bar-logo img-fluid bg-transparent\" [nzSrc]=\"logo? logo:null\" [ngClass]=\"{'bg-transparent': !logo}\"></nz-avatar>\r\n          </div>\r\n          <div class=\"b2c-product-title align-self-center\" *ngIf=\"!isMobile\">\r\n            <span nz-text>{{productName}}</span>\r\n          </div>\r\n        </div>\r\n    </div>\r\n    <div nz-col nzSpan=\"12\">\r\n      <!-- Investment Info Container -->\r\n      <div class=\"b2c-product-bar-investment-info\" [ngClass]=\"{'text-left':isMobile,'text-center':!isMobile}\">\r\n        <!-- Web View -->\r\n          <div class=\"row\"  *ngIf=\"!isMobile && showInfo\">\r\n            <div class=\"col\">\r\n              <span nz-text class=\"label\">{{firstInfoTitle}}</span>\r\n            </div>\r\n\r\n            <div class=\"col\">\r\n              <span nz-text class=\"value\">{{firstValuePrefix}} {{firstValue | number}} {{firstValueSuffix}}</span>\r\n            </div>\r\n\r\n            <div class=\"col\">\r\n              <nz-divider class=\"b2c-product-bar-divider\" *ngIf=\"secondValue\"  nzType=\"vertical\"></nz-divider>\r\n            </div>\r\n\r\n            <div class=\"col\" >\r\n              <span nz-text class=\"label\">{{secondInfoTitle}}</span>\r\n            </div>\r\n\r\n            <div class=\"col\">\r\n              <span nz-text class=\"value\" *ngIf=\"type !== 'stock' && type!=='etf'\" >{{secondValuePrefix}} {{secondValue | number}} {{secondValueSuffix}}</span>\r\n            </div>\r\n\r\n        </div>\r\n\r\n        <!-- Mobile View-->\r\n        <ng-container *ngIf=\"isMobile && showInfo\">\r\n          <div class=\"b2c-product-bar-mobile-investment-info\">\r\n            <span nz-text class=\"mobile-title d-flex\">{{firstInfoTitle}}</span>\r\n            <span nz-text class=\"mobile-value d-flex font-weight-bold\">{{firstValuePrefix}} {{firstValue | number}} {{firstValueSuffix}}</span>\r\n          </div>\r\n        </ng-container>\r\n        <!------------------------>\r\n        </div>\r\n    </div>\r\n    <div nz-col [nzSpan]=\"isMobile? 12:5\">\r\n      <!-- Button Container -->\r\n      <ng-container *ngIf=\"showInfo\">\r\n        <div nz-col class=\"b2c-product-bar-button-container text-right\">\r\n          <button\r\n          class=\"b2c-product-bar-btn-transact font-weight-bold\"\r\n          nz-button\r\n          nzType=\"primary\"\r\n          (click)=\"onTrade(productName)\">{{ I18nTransKey?.TRANSACT | b2cI18n }}</button>\r\n\r\n          <!-- Show on Web (WatchList Button)-->\r\n          <button\r\n          nz-button\r\n          nz-tooltip\r\n          [nzTooltipTitle]=\"'Add to watchlist'\"\r\n          nzType=\"default\"\r\n          class=\"btn-outline-icon align-top\"\r\n          *ngIf=\"!isMobile\"\r\n          (click)=\"addToWatchlist(isWatchList)\">\r\n            <b2c-ui-icon\r\n              name=\"addToWatchlistIcon\">\r\n            </b2c-ui-icon>\r\n          </button>\r\n\r\n\r\n          <button\r\n          nz-button\r\n          nz-tooltip\r\n          [nzTooltipTitle]=\"isAlertAdded? 'Remove alert' : 'Add alert'\"\r\n          nzType=\"default\"\r\n          class=\"btn-outline-icon align-top\"\r\n          *ngIf=\"!isMobile && alert\"\r\n          [ngClass]=\"isAlertAdded? 'added' : ''\"\r\n          (click)=\"addToAlert(isAlertAdded)\"\r\n          >\r\n            <b2c-ui-icon *ngIf=\"isAlertAdded\" class=\"alert-added\"\r\n              name='alertaddedIcon'>\r\n            </b2c-ui-icon>\r\n            <b2c-ui-icon *ngIf=\"!isAlertAdded\"\r\n              name='alertIcon'>\r\n            </b2c-ui-icon>\r\n          </button>\r\n\r\n        </div>\r\n      </ng-container>\r\n\r\n      <ng-container *ngIf=\"!showInfo\">\r\n      <div   class=\"b2c-product-bar-button-container text-right\">\r\n        <button nz-button nzType=\"primary\" class=\"b2c-product-bar-btn-transact\" (click)=\"onTrade(productName)\" nzBlock>{{ I18nTransKey?.TRANSACT | b2cI18n }}</button>\r\n      </div>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.ResponsiveService }]; }, { type: [{
            type: Input
        }], transact: [{
            type: Output
        }], watchlistChange: [{
            type: Output
        }], alertChange: [{
            type: Output
        }], isMobile: [{
            type: Input
        }], alert: [{
            type: Input
        }], isAlertAdded: [{
            type: Input
        }], showInfo: [{
            type: Input
        }], isWatchList: [{
            type: Input
        }], logo: [{
            type: Input
        }], productName: [{
            type: Input
        }], firstInfoTitle: [{
            type: Input
        }], secondInfoTitle: [{
            type: Input
        }], firstValue: [{
            type: Input
        }], secondValue: [{
            type: Input
        }], firstValuePrefix: [{
            type: Input
        }], secondValuePrefix: [{
            type: Input
        }], firstValueSuffix: [{
            type: Input
        }], secondValueSuffix: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CProductBarComponent.prototype._isMobile;
    /**
     * @type {?}
     * @private
     */
    B2CProductBarComponent.prototype._showInfo;
    /**
     * @type {?}
     * @private
     */
    B2CProductBarComponent.prototype._isWatchList;
    /**
     * @type {?}
     * @private
     */
    B2CProductBarComponent.prototype._alert;
    /**
     * @type {?}
     * @private
     */
    B2CProductBarComponent.prototype._isAlertAdded;
    /**
     * @ignore
     * @type {?}
     */
    B2CProductBarComponent.prototype.I18nTransKey;
    /**
     * set product bar type
     * @type {?}
     */
    B2CProductBarComponent.prototype.type;
    /**
     * Set product logo
     * @type {?}
     */
    B2CProductBarComponent.prototype.logo;
    /**
     * Set product name
     * @type {?}
     */
    B2CProductBarComponent.prototype.productName;
    /**
     * Set first investment info title (will show in mobile view)
     * @type {?}
     */
    B2CProductBarComponent.prototype.firstInfoTitle;
    /**
     * Set second investment info title (not show in mobile view)
     * @type {?}
     */
    B2CProductBarComponent.prototype.secondInfoTitle;
    /**
     * Set first investment info value (will show in mobile view)
     * @type {?}
     */
    B2CProductBarComponent.prototype.firstValue;
    /**
     * Set second investment info value (not show in mobile view)
     * @type {?}
     */
    B2CProductBarComponent.prototype.secondValue;
    /**
     * Set prefix of first investment info value
     * @type {?}
     */
    B2CProductBarComponent.prototype.firstValuePrefix;
    /**
     * Set prefix of second investment info value
     * @type {?}
     */
    B2CProductBarComponent.prototype.secondValuePrefix;
    /**
     * Set suffix of first investment info value
     * @type {?}
     */
    B2CProductBarComponent.prototype.firstValueSuffix;
    /**
     * Set suffix of second investment info value
     * @type {?}
     */
    B2CProductBarComponent.prototype.secondValueSuffix;
    /**
     * Transact button change
     * @type {?}
     */
    B2CProductBarComponent.prototype.transact;
    /**
     * Watchlist change
     * @type {?}
     */
    B2CProductBarComponent.prototype.watchlistChange;
    /** @type {?} */
    B2CProductBarComponent.prototype.alertChange;
    /** @type {?} */
    B2CProductBarComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    B2CProductBarComponent.prototype.cdRef;
    /**
     * @type {?}
     * @private
     */
    B2CProductBarComponent.prototype.responsiveService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-product-bar-filter.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CProductBarFilterComponent {
    /**
     * @ignore
     * @param {?} elementRef
     * @param {?} cdRef
     * @param {?} responsiveService
     */
    constructor(elementRef, cdRef, responsiveService) {
        this.elementRef = elementRef;
        this.cdRef = cdRef;
        this.responsiveService = responsiveService;
        /**
         * @ignore
         */
        this.I18nTransKey = I18nTransKey;
        this.filter = new EventEmitter();
        this.clear = new EventEmitter();
        this.cancel = new EventEmitter();
        this.responsiveService
            .observeBoolean(breakpointBelow.sm)
            .pipe(tap((/**
         * @param {?} matched
         * @return {?}
         */
        (matched) => {
            this.isMobile = matched;
            this.cdRef.markForCheck();
        })))
            .subscribe();
    }
    /**
     * Set Mobile View
     * @param {?} value
     * @return {?}
     */
    set isMobile(value) {
        this._isMobile = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get isMobile() {
        return this._isMobile;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set oneButton(value) {
        this._oneButton = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get oneButton() {
        return this._oneButton;
    }
    /**
     * Set Filter
     * @param {?} value
     * @return {?}
     */
    set selectedFilter(value) {
        this._selectedFilter = value;
    }
    /**
     * @return {?}
     */
    get selectedFilter() {
        return this._selectedFilter;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onClear(value) {
        this.clear.emit(value);
        _log('clear button click, Clear:');
        this.selectedFilter = null;
        _log(value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onCancel(value) {
        this.cancel.emit(value);
        _log('cancel button click');
        _log(value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onFilter(value) {
        this.filter.emit(value);
        _log('filter button click');
        _log(value);
    }
}
B2CProductBarFilterComponent.ɵfac = function B2CProductBarFilterComponent_Factory(t) { return new (t || B2CProductBarFilterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService)); };
B2CProductBarFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CProductBarFilterComponent, selectors: [["b2c-product-bar-filter"]], inputs: { isMobile: "isMobile", oneButton: "oneButton", selectedFilter: "selectedFilter" }, outputs: { filter: "filter", clear: "clear", cancel: "cancel" }, decls: 7, vars: 10, consts: [["nz-row", "", "nzType", "flex", 1, "b2c-product-bar-filter", "container-fluid", "bg-white", "shadow", "overflow-hidden"], ["nz-col", "", "nzSpan", "24", 1, "b2c-product-bar-filter-inner", "container-fluid", 3, "ngClass"], ["nz-button", "", "class", "b2c-product-bar-filter-btn-cancel mr-3", "nzType", "outline", 3, "click", 4, "ngIf"], ["nz-button", "", "class", "b2c-product-bar-filter-btn-clear mr-3", "nzType", "outline", 3, "ngClass", "click", 4, "ngIf"], ["nz-button", "", "nzType", "primary", 1, "b2c-product-bar-filter-btn-filter", 3, "ngClass", "click"], ["nz-button", "", "nzType", "outline", 1, "b2c-product-bar-filter-btn-cancel", "mr-3", 3, "click"], ["nz-button", "", "nzType", "outline", 1, "b2c-product-bar-filter-btn-clear", "mr-3", 3, "ngClass", "click"]], template: function B2CProductBarFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, B2CProductBarFilterComponent_button_2_Template, 3, 3, "button", 2);
        ɵngcc0.ɵɵtemplate(3, B2CProductBarFilterComponent_button_3_Template, 3, 6, "button", 3);
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵlistener("click", function B2CProductBarFilterComponent_Template_button_click_4_listener() { return ctx.onFilter(ctx.selectedFilter); });
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "b2cI18n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.oneButton ? "text-center" : "text-right");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.oneButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.oneButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c5, ctx.oneButton, ctx.oneButton));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 5, ctx.I18nTransKey == null ? null : ctx.I18nTransKey.FILTER));
    } }, directives: [ɵngcc3.NzRowDirective, ɵngcc3.NzColDirective, ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc7.NzButtonComponent], pipes: [ɵngcc10.B2CI18nPipe], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CProductBarFilterComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef },
    { type: ResponsiveService }
];
B2CProductBarFilterComponent.propDecorators = {
    isMobile: [{ type: Input }],
    oneButton: [{ type: Input }],
    selectedFilter: [{ type: Input }],
    filter: [{ type: Output }],
    clear: [{ type: Output }],
    cancel: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CProductBarFilterComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'b2c-product-bar-filter',
                template: "<div class=\"b2c-product-bar-filter container-fluid bg-white shadow overflow-hidden\" nz-row nzType=\"flex\" >\r\n  <div class=\"b2c-product-bar-filter-inner container-fluid\" [ngClass]=\"oneButton? 'text-center':'text-right'\" nz-col nzSpan=\"24\" >\r\n\r\n    <button *ngIf=\"!oneButton\" nz-button class=\"b2c-product-bar-filter-btn-cancel mr-3\" nzType=\"outline\" (click)=\"onCancel(selectedFilter)\">{{ I18nTransKey?.CANCEL | b2cI18n }}</button>\r\n    <button *ngIf=\"!oneButton\" nz-button class=\"b2c-product-bar-filter-btn-clear mr-3\" [ngClass]=\"{'my-2':isMobile}\" (click)=\"onClear(selectedFilter)\" nzType=\"outline\">{{ I18nTransKey?.CLEAR_SELECTED_FILTER | b2cI18n }}</button>\r\n    <button nz-button class=\"b2c-product-bar-filter-btn-filter\" [ngClass]=\"{'w-100':oneButton,'isMobile':oneButton}\" nzType=\"primary\" (click)=\"onFilter(selectedFilter)\">{{ I18nTransKey?.FILTER | b2cI18n }}</button>\r\n\r\n  </div>\r\n</div>\r\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.ResponsiveService }]; }, { filter: [{
            type: Output
        }], clear: [{
            type: Output
        }], cancel: [{
            type: Output
        }], isMobile: [{
            type: Input
        }], oneButton: [{
            type: Input
        }], selectedFilter: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CProductBarFilterComponent.prototype._isMobile;
    /**
     * @type {?}
     * @private
     */
    B2CProductBarFilterComponent.prototype._selectedFilter;
    /**
     * @type {?}
     * @private
     */
    B2CProductBarFilterComponent.prototype._oneButton;
    /**
     * @ignore
     * @type {?}
     */
    B2CProductBarFilterComponent.prototype.I18nTransKey;
    /** @type {?} */
    B2CProductBarFilterComponent.prototype.filter;
    /** @type {?} */
    B2CProductBarFilterComponent.prototype.clear;
    /** @type {?} */
    B2CProductBarFilterComponent.prototype.cancel;
    /** @type {?} */
    B2CProductBarFilterComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    B2CProductBarFilterComponent.prototype.cdRef;
    /**
     * @type {?}
     * @private
     */
    B2CProductBarFilterComponent.prototype.responsiveService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-product-bar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ICONS = [AddToWatchlistIcon, AlertIcon, AlertaddedIcon];
class B2CProductBarModule {
    /**
     * @param {?} b2cIconService
     */
    constructor(b2cIconService) {
        this.b2cIconService = b2cIconService;
        this.b2cIconService.registerIcons([...ICONS]);
    }
}
B2CProductBarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CProductBarModule });
B2CProductBarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CProductBarModule_Factory(t) { return new (t || B2CProductBarModule)(ɵngcc0.ɵɵinject(ɵngcc9.B2CUiIconService)); }, imports: [[
            CommonModule,
            NzGridModule,
            NzDividerModule,
            NzButtonModule,
            NzCardModule,
            NzAvatarModule,
            NzTypographyModule,
            B2cUiIconModule,
            NzToolTipModule,
            I18nModule
        ]] });
/** @nocollapse */
B2CProductBarModule.ctorParameters = () => [
    { type: B2CUiIconService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CProductBarModule, { declarations: function () { return [B2CProductBarComponent,
        B2CProductBarFilterComponent]; }, imports: function () { return [CommonModule,
        NzGridModule,
        NzDividerModule,
        NzButtonModule,
        NzCardModule,
        NzAvatarModule,
        NzTypographyModule,
        B2cUiIconModule,
        NzToolTipModule,
        I18nModule]; }, exports: function () { return [B2CProductBarComponent,
        B2CProductBarFilterComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CProductBarModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CProductBarComponent, B2CProductBarFilterComponent],
                exports: [B2CProductBarComponent, B2CProductBarFilterComponent],
                imports: [
                    CommonModule,
                    NzGridModule,
                    NzDividerModule,
                    NzButtonModule,
                    NzCardModule,
                    NzAvatarModule,
                    NzTypographyModule,
                    B2cUiIconModule,
                    NzToolTipModule,
                    I18nModule
                ]
            }]
    }], function () { return [{ type: ɵngcc9.B2CUiIconService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CProductBarModule.prototype.b2cIconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-product-bar.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CProductBarComponent, B2CProductBarFilterComponent, B2CProductBarModule };


//# sourceMappingURL=b2c-ui-product-bar.js.map